import { useSelector } from "react-redux";
import Modal from "../../../../components/Modal";
import { ADD_FAVOURITES_VIEW } from "../../../../constants";
import styles from "./AddFavourites.module.scss";
import { AddFavouritesHeader } from "../../components/AddFavouritesHeader";
import { FavView } from "../../components/FavView";

export const AddFavourites = () => {
  const { activeView } = useSelector((state) => state.view);
  if (activeView !== ADD_FAVOURITES_VIEW) return null;
  return (
    <Modal variant={ADD_FAVOURITES_VIEW}>
      <div className={styles.addFavouritesView}>
        <AddFavouritesHeader />
        <FavView />
      </div>
    </Modal>
  );
};
